if ( objects.is_onepage || objects.is_front_page ) {
//    var controller = new ScrollMagic.Controller();
//
//    // loop through all elements except first and last
//    $('main section').not(':first-child').not(':last').each(function () {
//
//        // build a tween
//        var mainSection = TweenMax.from($(this), 0.3, {
//            autoAlpha: 0.5,
//            y: '+=30',
//            ease: Linear.easeNone
//        });
//
//        // build a scene
//        var scene = new ScrollMagic.Scene({
//                triggerElement: this
//            })
//            .setTween(mainSection) // trigger a TweenMax.to tween
//            .addTo(controller);
//    });
}